import { PaletteOptions } from '@mui/material'

const paletteBase: Partial<PaletteOptions> = {
  primary: {
    light: '#5FB1E5',
    main: '#1974A5',
    dark: '#003956',
    contrastText: '#fbfbfb',
  },
  secondary: {
    light: '#FDE6A8',
    main: '#ffaf35',
    dark: '#D0821C',
    contrastText: '#fbfbfb',
  },
}

export default paletteBase
